import { helpers } from '@vuelidate/validators'
import {useI18n} from 'vue-i18n'

export function useValidators() {
	const {t} = useI18n()

	const phoneRegex = new RegExp(
		"^(" +
		"(?:\\+|00)(?:421|420)\\s?\\d{3}\\s?\\d{3}\\s?\\d{3}|" + // Slovakia, Czech Republic (Strictly 9 digits after country code)
		"(?:\\+|00)(?:43|49|36)\\s?\\d{1,4}\\s?\\d{3,4}\\s?\\d{3,4}|" + // Austria, Germany, Hungary (Variable length)
		"09\\d{2}\\s?\\d{3}\\s?\\d{3}" + // Slovak local mobile numbers (09xx xxx xxx)
		")$"
	)

	const phoneValidator = helpers.withMessage(
		t(`Invalid phone number. Please use international format. Ex.: +420901123123`),
		helpers.regex(phoneRegex)
	)

	return {
		phoneValidator,
	}
}
